import { find, isEmpty } from 'lodash';
import { AccountPlan } from '@zapier/design-system-revenue/src/types';

/**
 * Handle very special case where legacy plan from old plan group is still hanging
 * around, but it's not the current plan anymore - don't show it.
 */
export const removeUnusedLegacyPlans = (
  plans: Array<AccountPlan>,
  currentPlanId: number
): Array<AccountPlan> => {
  return plans.filter(plan => {
    if (!plan || isEmpty(plan)) {
      return false;
    }

    if (!plan.name.match(/legacy/i)) {
      return true;
    }

    return find(plan.intervals, i => i.id === currentPlanId);
  });
};
